import { Box, Button, Grid, Skeleton, Typography } from "@mui/material";
import CartBookingDetails from "components/cart/cart-booking-details";
import CartItems from "components/cart/cart-items";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchCart } from "slices/cartReducer";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import { getCartCache } from "utils/cart.util";

const CartPage = () => {
  const navigate = useNavigate();
  const { loadingCart, items } = useAppSelector((state) => state.cartReducer);
  const dispatch = useAppDispatch();
  const defaultCache = getCartCache();
  const [checkoutDates, setCheckoutDates] = useState({
    start:
      defaultCache && defaultCache?.from_date ? defaultCache?.from_date : null,
    end: defaultCache && defaultCache?.to_date ? defaultCache?.to_date : null,
  });

  useEffect(() => {
    dispatch(fetchCart({ query: "" }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box sx={{ mx: "4%", my: "30px" }}>
      <Typography
        sx={{
          color: "#323232",
          lineHeight: "31px",
          fontWeight: 600,
          fontSize: "26px",
        }}
      >
        Your Cart
      </Typography>
      {loadingCart && (
        <Grid container spacing={3} sx={{ mt: "30px" }}>
          <Grid item sm={12} xs={12} md={7} lg={7} xl={7}>
            <Skeleton variant="rectangular" height="300px" />
          </Grid>{" "}
          <Grid item sm={12} xs={12} md={5} lg={5} xl={5}>
            <Skeleton variant="rectangular" height={200} sx={{ mb: 3 }} />
            <Skeleton variant="rectangular" height={200} sx={{ mb: 3 }} />
            <Skeleton variant="rectangular" height={200} sx={{ mb: 3 }} />
          </Grid>
        </Grid>
      )}
      {!loadingCart && items.length > 0 && (
        <Grid container spacing={3}>
          <Grid item sm={12} xs={12} md={7} lg={7} xl={7}>
            <CartItems checkoutDates={checkoutDates} />
          </Grid>{" "}
          <Grid item sm={12} xs={12} md={5} lg={5} xl={5}>
            <CartBookingDetails setCheckoutDates={setCheckoutDates} />
          </Grid>
        </Grid>
      )}
      {!loadingCart && items.length === 0 && (
        <Box
          sx={{
            mx: "4%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            width: "100%",
            my: "8%",
          }}
        >
          <img src="/assets/img/icons/cart_empty.svg" alt="" width="271px" />
          <Typography
            sx={{
              color: "#323232",
              fontWeight: 700,
              fontSize: "26px",
              lineHeight: "31px",
              mt: "20px",
              mb: "10px",
              textAlign: "center",
            }}
          >
            Your Cart is Empty!
          </Typography>
          <Typography
            sx={{
              color: "#A2A2A2",
              fontWeight: 500,
              fontSize: "16px",
              lineHeight: "24px",
              mb: "15px",
              textAlign: "center",
            }}
          >
            Looks like you haven’t added anything to your card. Go ahead &
            explore our tractor and attachment
          </Typography>

          <Button
            variant="contained"
            sx={{
              borderRadius: "10px",
              height: "56px",
              mt: "15px",
              width: "200px",
            }}
            onClick={() => navigate("/search-listing")}
          >
            Explore
          </Button>
        </Box>
      )}
      {!loadingCart && items.length > 0 && (
        <Typography
          sx={{ fontWeight: 600, fontSize: "15px", lineHeight: "22px" }}
        >
          <Typography
            component="span"
            color="error"
            sx={{ fontWeight: 600, fontSize: "15px", lineHeight: "22px" }}
          >
            Please note:
          </Typography>{" "}
          Remember, while returning your items, additional charges such as
          loading fees, pickup/delivery fees, may apply. (if it is applicable)
        </Typography>
      )}
    </Box>
  );
};

export default CartPage;
